module.exports = __webpack_public_path__ + "fonts/IstokWeb-Italic.fec41dff.ttf";